<template>
	<div class="cm-mobile-bar cm-mobile-toolbar">
		<div class="container h-100 position-relative">
			<transition name="cm-zoom-out">
				<div class="mobile-body toolbar-body" v-if="list.init">
					<div
						class="row h-100 g-0 justify-content-between align-items-stretch"
					>
						<div class="col">
							<a
								data-bs-toggle="modal"
								href="#modalShareSearch"
								class="link-toolbar-sm"
								><i class="mdi mdi-share-variant"></i> Teilen</a
							>
						</div>
						<div class="col">
							<a
								data-bs-toggle="modal"
								href="#modalBookmarks"
								class="link-toolbar-sm border-start"
								><i class="mdi mdi-bookmark-outline"></i> Merkliste
								<transition name="cm-zoom-out">
									<span
										v-if="totalCarBookmarks > 0"
										class="badge bg-primary badge-upper"
										>{{ totalCarBookmarks }}
										<span class="visually-hidden">merkliste</span>
									</span>
								</transition>
							</a>
						</div>
						<div class="col">
							<a
								href="#"
								@click.prevent="showMobileContent('search')"
								class="link-toolbar-sm border-start"
								><i class="mdi mdi-magnify"></i> Suchen</a
							>
						</div>
						<div class="col">
							<a
								href="#"
								@click.prevent="showMobileContent('sort')"
								class="link-toolbar-sm border-start"
								><i class="mdi mdi-sort"></i> Sortieren</a
							>
						</div>
						<div class="col-3" style="min-width: 108px">
							<a
								href="#"
								@click.prevent="showMobileContent('filter')"
								class="link-toolbar border-start"
								><i class="mdi mdi-filter"></i> Filter</a
							>
						</div>
					</div>
				</div>
			</transition>
			<div class="toolbar-dropup">
				<transition-group name="cm-bottom-slide">
					<div
						v-if="mobile.show === 'search'"
						class="cm-mobile-search cm-mobile-body dropup-body"
					>
						<div class="d-flex justify-content-between g-0 mb-2">
							<h5>Volltextsuche</h5>
							<button
								type="button"
								class="btn btn-sm font-20"
								@click="showMobileContent('search')"
							>
								<i class="mdi mdi-close-thick"></i>
							</button>
						</div>
						<form-text-search
							btn-dark
							@update-filter="updateFilter"
						></form-text-search>
						<button
							type="button"
							class="btn my-2 btn-link link-dark btn-block"
							@click="showMobileContent('search')"
						>
							Abbrechen
						</button>
					</div>
					<div
						v-if="mobile.show === 'sort'"
						class="cm-mobile-sort cm-mobile-body dropup-body"
					>
						<div class="d-flex justify-content-between w-100 g-0 mb-2">
							<h5>Sortieren nach</h5>
							<button
								type="button"
								class="btn btn-sm font-18"
								@click="showMobileContent('sort')"
							>
								<i class="mdi mdi-close-thick"></i>
							</button>
						</div>
						<form-select-sort @update-list="updateList" />
						<button
							type="button"
							class="btn my-2 btn-dark btn-block"
							@click="updateList"
						>
							Anwenden
						</button>

						<button
							type="button"
							class="btn my-2 btn-link link-dark btn-block"
							@click="showMobileContent('sort')"
						>
							Abbrechen
						</button>
					</div>
				</transition-group>
			</div>
		</div>
	</div>
	<transition name="cm-left-slide">
		<div
			class="cm-mobile-filter cm-mobile-sidebar cm-mobile-side"
			v-if="mobile.show === 'filter'"
		>
			<button
				type="button"
				class="btn-filter-close btn btn-close"
				@click="showMobileContent('filter')"
			></button>
			<div v-if="filter.init" class="mobile-filter-scroll cm-mobile-scroll">
				<div class="cm-filters-mobile">
					<list-filter
						:filter-loading="filter.loading"
						:filter-fields="filter.fields"
						:count-total="list.countTotal"
						:ref-data="refData"
						@update-filter="updateFilter"
					/>
				</div>
			</div>
			<div class="mobile-filter-footer cm-mobile-btn-container">
				<button
					class="btn btn-dark btn-lg btn-pill btn-block btn-filter-show"
					type="button"
					@click="showMobileContent('filter')"
				>
					<vue3-autocounter
						ref="counter"
						:startAmount="countTotalOld"
						:endAmount="list.countTotal"
						:duration="1"
						suffix=" Treffer anzeigen"
						:decimals="0"
						:autoinit="true"
						@finished="countTotalOld = list.countTotal"
					/>

					<transition name="cm-fade">
						<div
							v-if="filter.loading"
							class="amd-loader loader-light loader-btn loader-noicon"
							role="status"
							aria-hidden="true"
						>
							<div class="loading"></div>
						</div>
					</transition>
				</button>
			</div>
		</div>
	</transition>
	<transition name="cm-fade">
		<div
			class="cm-mobile-backdrop"
			v-if="mobile.show !== ''"
			@click="mobile.show = ''"
		></div>
	</transition>
</template>

<script>
import ListFilter from '@/components/list/ListFilter'
import FormSelectSort from '@/components/ui/form/FormSelectSort'
import FormTextSearch from '@/components/ui/form/FormTextSearch'
import Vue3autocounter from 'vue3-autocounter'

export default {
	name: 'ListMobileToolbar',
	components: {
		FormTextSearch,
		FormSelectSort,
		ListFilter,
		'vue3-autocounter': Vue3autocounter,
	},
	emits: ['updateFilter', 'updateList'],
	props: {
		list: Object,
		filter: Object,
		firstInit: Boolean,
		refData: Object,
		countActiveFilters: Number,
		totalCarBookmarks: Number,
	},
	data() {
		return {
			countTotalOld: 0,
			mobile: {
				show: '',
			},
			user: {
				browser: '',
			},
			searchUrl: '',
			searchTitle: 'Meine Suche 1',
			bookmarks: {
				cars: {},
				search: {},
			},
		}
	},
	methods: {
		updateFilter() {
			if (this.mobile.show !== 'filter') {
				this.mobile.show = ''
			}
			this.$emit('updateFilter')
		},
		updateList() {
			this.mobile.show = ''
			this.$emit('updateList')
		},
		showMobileContent(show) {
			this.mobile.show = show === this.mobile.show ? '' : show
		},
	},
}
</script>

<style scoped></style>
